<template>
    <q-card class="row banner-button">

        <q-card-main @click.prevent="console.log('click')">
            <q-item link :to="to" class="">
                <img v-if="img.url!=null" :src="img.url" />
                <p v-else>{{alt}}</p>
            </q-item>
        </q-card-main>
    </q-card>
</template>

<script>
    import {QItem,QCard,QCardMain} from 'quasar-framework';
    import axios from 'axios';
    export default {
        name: 'BannerButton',
        components:{
            QItem,
            QCard,
            QCardMain
        },
        props:{
            to: {
                type: String,
                required: true
            },
            contentType:{
                type: String,
                required: true
            }
        },
        data(){
            return {
                img:{url:''},
                alt:'',
            }
        },
        methods:{
            getBanner(){
                axios.get(`${config.appUrl}/api/get-bo-banner/${this.contentType}`)
                    .then(({data}) => {
                        this.img     = data.img;
                        this.alt     = data.alt;
                    })
            }
        },
        mounted(){
            this.getBanner();
        }
    }
</script>

<style lang="stylus" scoped>
    .banner-button
        margin 40px auto
        background-color transparent
        max-width 1110px
        border-radius 0
        box-shadow none
        border none

        .q-item,
        .q-item-division,
        .q-item-link,
        .q-card-container
            padding 0

        img
            max-height 100px
            width 100%
            height auto

        @media (max-width 1200px)
            max-width 930px

        @media (max-width 992px)
            height 100px
            padding 0 15px
            img
                height 100px
                width 100%
                object-fit cover
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/BannerButton.vue